var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorials(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#Path_221);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb109"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_221",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.388
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_154_27",
    "data-name": "Component 154 \\u2013 27",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    className: "cls-1",
    width: 49,
    height: 63,
    rx: 24.5,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    className: "cls-2",
    d: "M31.5,0A31.5,31.5,0,1,1,0,31.5,31.5,31.5,0,0,1,31.5,0Z",
    transform: "translate(4.5 4.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Video",
    "data-name": "Iconly/Bold/Video",
    transform: "translate(13.999 14.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(2 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-1",
    d: "M16.823,0a6.641,6.641,0,0,1,6.986,6.9h0V18.58a6.641,6.641,0,0,1-6.986,6.9H6.986A6.641,6.641,0,0,1,0,18.58H0V6.9A6.641,6.641,0,0,1,6.986,0h9.838ZM30.5,4.041a2.348,2.348,0,0,1,2.332.109A2.429,2.429,0,0,1,33.969,6.22h0V19.258a2.427,2.427,0,0,1-1.136,2.071,2.376,2.376,0,0,1-1.262.367,2.352,2.352,0,0,1-1.072-.26h0l-2.515-1.269a2.757,2.757,0,0,1-1.508-2.474h0V7.784a2.749,2.749,0,0,1,1.508-2.473h0Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.20fe62a600223b20d432baa3bb6474d5.svg";
export { ForwardRef as ReactComponent };